(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'postgradSummaryCard', {
            bindings: {
                /** `vm.metadata` can be required by some of the included components (fees, key dates) - make an alias of this rather than renaming it if necessary */
                metadata:               '<', // Expects immutable object
                ctaButtonOpts:          '<',
                showSubqualInfo:        '<',
            },
            templateUrl:  'app/views/partials/widgets/postgrad-summary-card.html',
            controller:   PostgradSummaryCardController,
            controllerAs: 'vm'
        })

        .component( 'postgradOverview', {
            bindings: {
                /** `vm.metadata` can be required by some of the included components (fees, key dates) - make an alias of this rather than renaming it if necessary */
                metadata:               '<', // Expects immutable object
                showSubqualInfo:        '<',
            },
            templateUrl:  'app/views/partials/widgets/postgrad-overview.html',
            controller:   PostgradSummaryCardController,
            controllerAs: 'vm'
        });


    /**
     * Tile-based card summarising main postgraduate programme's attribute.
     * Designed to be easily comparable with others.
     *
     * Important: In case any significant changes are made to this component,
     * please re-test according to the https://victoriauniversity.atlassian.net/wiki/spaces/WT/pages/168198145/Blackbox+testing+guide+for+Topics+Programmes#BlackboxtestingguideforTopics&Programmes-Postgraduate'summary'cards
     *
     * @param {Lodash} _
     * @param {ng.IScope} $scope
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {SelectablesService} SelectablesService
     * @param {SubpagesService} SubpagesService
     * @param {TrackerService} TrackerService
     * @param {LoggerService} LoggerFactory
     * @param {Utils} Utils
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function PostgradSummaryCardController(
        _,
        $scope,
        ContentSwitchingService,
        SelectablesService,
        SubpagesService,
        TrackerService,
        LoggerFactory,
        Utils,
        TEXTS,
        CONFIG
    ){

        /** @type {angular.IController} */
        var vm     = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @const */
        var RESPONSE_ATTRIBUTE_PARENT_ID = 'id',
        RESPONSE_ATTRIBUTE_PARENT                  = 'parent',
        RESPONSE_ATTRIBUTE_TYPE          = 'type',
        RESPONSE_ATTRIBUTE_SUBQUAL_ID    = 'id',
        RESPONSE_ATTRIBUTE_IS_STANDALONE = 'orphan';


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'PostgradSummaryCard' );




        /* ===== EXPOSE TO THE SCOPE ======================================== */


        $scope._            = TEXTS.POSTGRAD.SUMMARY_CARD;
        $scope.Utils        = Utils;

        $scope.SUBQUAL_TYPE_ACADEMIC_POSTGRAD = 'subject';






        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        /** @const */
        vm.KIS_IMAGE_SRC = CONFIG.UI.PATHS.IMAGES.KIS_LANDSCAPE;


        // Members
        vm.isPostgradSubpage    = SubpagesService.isPostgradSubpage();


        // Methods
        vm.setFeesVisibility = function( feesVisibilityFlag ) {
            vm.areFeesVisible = feesVisibilityFlag;
        };

        vm.setKeyDatesCount = function( datesModel ) {
            vm.keyDatesCount = datesModel ? datesModel.length : null;
        };

        vm.trackKisCtr = TrackerService.logKISClick;





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        vm.$onInit = function() {
            setWatchers();
        };


        /** *MUST BE* present to allow directive `collapsible` to bind to the Controller's $postLink event. */
        Utils.addGenericPostLinkTrigger( vm );





        /* ===== PRIVATE FUNCTIONS ========================================== */


        /** Uni-directional watchers */
        vm.$onChanges = function( changesObject ) {
            if ( changesObject.metadata && changesObject.metadata.currentValue ){
                initModel();
                vm.$onChanges = function(){}; // Deregister event handler after qual's metadata are loaded
            }
        };



        function setWatchers() {
            $scope.$watch( 'ContentSwitchingService.contentType', function() {
                vm.isInternationalContent = ContentSwitchingService.isInternational();

                if ( vm.hasOwnProperty( 'metadata' ) && vm.metadata ){
                    vm.qual = vm.isInternationalContent && vm.metadata.hasOwnProperty( 'international' ) ? vm.metadata[ 'international' ] : vm.metadata;
                }
            });
        }


        function initModel() {
            if ( vm.metadata ){
                vm.isForOverseasOnly = vm.metadata.hasOwnProperty( 'code' ) && ( vm.metadata.code === 'UGCoP' || vm.metadata.code === 'PGCoP' );

                initCTAButton();
                initKISDisplayType();
                ContentSwitchingService.initInternationalOnObject( vm.metadata );
            } else {
                logger.error( "(Sub)qualification is missing a `metadata` attribute - Cannot render its summary card!" );
            }
        }


        /**
         * Makes the main CTA button available at `vm.ctaButton`.
         */
        function initCTAButton() {
            var DEFAULT_CTA_BUTTON = {
                stateId:    CONFIG.STATES.POSTGRADS.ABOUT,
                label:      $scope._.BUTTONS.EXPLORE_LABEL,
                title:      $scope._.BUTTONS.EXPLORE_TITLE
            };

            var ctaButtonObject = DEFAULT_CTA_BUTTON,
            targetStateQueries  = getQualsTargetStateQueries();


            // Override defaults by the `vm.ctaButtonOpts` if supplied to the directive
            _.assignIn( ctaButtonObject, vm.ctaButtonOpts );


            // If the state querie has built correctly, make button available to the Controller
            if ( targetStateQueries ){
                ctaButtonObject.targetStateParams = {
                    id:      ctaButtonObject.stateId,
                    queries: targetStateQueries
                }

                vm.ctaButton = ctaButtonObject;
            }
        }


        /**
         * Constructs parameters required by `ui-sref` template directive.
         * Might be used to dynamically construct URL to the given postgraduate
         * programme.
         *
         * @returns {null|Object}
         */
        function getQualsTargetStateQueries() {
            var stateQueries = {},
            qual             = vm.metadata;

            var isOrphanedQual = qual.hasOwnProperty( RESPONSE_ATTRIBUTE_IS_STANDALONE ) && qual[ RESPONSE_ATTRIBUTE_IS_STANDALONE ];


            // IS postgraduate / graduate-quals / other-quals detail
            if ( vm.isPostgradSubpage ) {

                // Only a single sub-qual inside given qual OR academic postgraduate - don't render the selectability button!
                if ( isOrphanedQual || SubpagesService.isPostgradAcademicSubpage() ){
                    return stateQueries;
                }

            } else {
                // NOT a postgraduate / graduate-quals / other-quals detail

                if ( qual.hasOwnProperty( RESPONSE_ATTRIBUTE_PARENT ) && qual[ RESPONSE_ATTRIBUTE_PARENT ].hasOwnProperty( RESPONSE_ATTRIBUTE_TYPE ) && qual[ RESPONSE_ATTRIBUTE_PARENT ].hasOwnProperty( RESPONSE_ATTRIBUTE_PARENT_ID ) ){

                    // Type + ID of the postgrad?
                    switch( qual.parent.type ){

                        case CONFIG.ROUTES.GRADUATE_QUALS: {
                            stateQueries[ CONFIG.PARAMS.POSTGRAD_ID ] = qual.parent.id;
                            stateQueries[ CONFIG.PARAMS.QUAL_TYPE ]   = CONFIG.ROUTES.GRADUATE_QUALS;
                        } break;

                        case CONFIG.ROUTES.OTHER_QUALS: {
                            stateQueries[ CONFIG.PARAMS.POSTGRAD_ID ] = qual.parent.id;
                            stateQueries[ CONFIG.PARAMS.QUAL_TYPE ]   = CONFIG.ROUTES.OTHER_QUALS;
                        } break;

                        case CONFIG.ROUTES.POSTGRADS: {
                            stateQueries[ CONFIG.PARAMS.POSTGRAD_ID ] = qual.parent.id;
                            stateQueries[ CONFIG.PARAMS.QUAL_TYPE ]   = CONFIG.ROUTES.POSTGRADS;
                        } break;

                        default: {
                            logger.error( "Unknown `parent.type` `%s` inside the metadata of qualification `%s` (#%s). Cannot construct a button that would link to the qualification's detail. Asset ID: %s", qual.parent.type, qual.parent.name, qual.id, qual.assetId );
                            return null;
                        }
                    }

                } else {
                    logger.error( "Missing object `%s` or one of its attributes `%s` or `%s`. Cannot construct a button that would link to the qualification's detail. Asset ID: %s", RESPONSE_ATTRIBUTE_PARENT, RESPONSE_ATTRIBUTE_TYPE, RESPONSE_ATTRIBUTE_PARENT_ID, qual.assetId );
                    return null;
                }
            }


            if ( !isOrphanedQual ) {
                // A Qual with multiple sub-quals -> Pre-select a sub-qual
                if ( qual.hasOwnProperty( RESPONSE_ATTRIBUTE_TYPE ) && qual[ RESPONSE_ATTRIBUTE_TYPE ] ){
                    stateQueries[ qual[ RESPONSE_ATTRIBUTE_TYPE ] ] = qual[ RESPONSE_ATTRIBUTE_SUBQUAL_ID ];
                } else {
                    logger.warn( "Missing attribute `%s` (or containing unknown value `%s`). The button will not pre-select a specific sub-qualification. Asset ID: %s", RESPONSE_ATTRIBUTE_TYPE, qual[ RESPONSE_ATTRIBUTE_TYPE ], qual.assetId );
                }
            }


            ContentSwitchingService.addGenericParamsToStateQuery( stateQueries );

            return stateQueries;
        }


        /**
         * Sets whether or not should be KIS element displayed as a simple
         * link and makes it avaiable as a `vm.showKISAsLink`.
         */
        function initKISDisplayType() {
            if ( SubpagesService.isPostgradAcademicSubpage() ){
                // Show clickable KIS image
                vm.showKISAsLink = false;
            } else {
                // Show KIS link
                vm.showKISAsLink = true;
            }
        }


        function isSubqualQuerySupported( queryName ) {
            return [ CONFIG.PARAMS.PROGRAMME, CONFIG.PARAMS.SUBJECT ].indexOf( queryName ) > -1;
        }


    }



    PostgradSummaryCardController.$inject = [ '_', '$scope', 'ContentSwitchingService', 'SelectablesService', 'SubpagesService', 'TrackerService', 'LoggerFactory', 'Utils', 'TEXTS', 'CONFIG' ];
})();
